import useTranslation from 'next-translate/useTranslation';
import { LinkToMapStyled, TextStyled } from './BoxMapCursor.partial.styles';

export const BoxMapCursor: React.FC<{
  className?: string;
  mapId: string;
  text: string;
  subtext: string;
  link: string | undefined;
}> = ({ className, mapId, text, subtext, link }) => {
  const { t } = useTranslation('common');

  return (
    <g id={`${mapId}_locationCursor`} style={{ display: 'none' }} className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M120 0H0V50H50L60 59L70 50H120V0Z"
        fill="#E63312"
      />
      <TextStyled text-anchor="middle" x="0" y="10">
        <tspan x="10" dy="0.8em">
          {text}
        </tspan>
        <tspan x="10" dy="1em">
          {subtext}
        </tspan>
        {link && (
          <tspan x="10" dy="1.2em">
            <LinkToMapStyled href={link}>{t('clickToMap')}</LinkToMapStyled>
          </tspan>
        )}
      </TextStyled>
    </g>
  );
};
